import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    price: null,
    posts: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const videoFeedbackSlice = createSlice({
  name: 'videoFeedback',
  initialState,
  reducers: {
    videoFeedbackStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        price: blockContent?.price ?? null,
        posts: blockContent?.posts ?? [],
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    videoFeedbackClear: () => initialState,

    videoFeedbackUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    videoFeedbackUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    videoFeedbackUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const {
  videoFeedbackStore,
  videoFeedbackClear,
  videoFeedbackUpdateIsLoading,
  videoFeedbackUpdateIsActive,
  videoFeedbackUpdateBlockContent,
} = videoFeedbackSlice.actions;

export const selectVideoFeedbackIsLoading = (state) => state.videoFeedback.isLoading;
export const selectVideoFeedbackId = (state) => state.videoFeedback.id;
export const selectVideoFeedbackUID = (state) => state.videoFeedback.uid;
export const selectVideoFeedbackSID = (state) => state.videoFeedback.sid;
export const selectVideoFeedbackBlockContent = (state) => state.videoFeedback.blockContent;
export const selectVideoFeedbackItemDesign = (state) => state.videoFeedback.itemDesign;
export const selectVideoFeedbackContainerDesign = (state) => state.videoFeedback.containerDesign;

export default videoFeedbackSlice.reducer;
